import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const CartPlus = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 640 512"
      {...props}
    >
      <path
        opacity={0.2}
        fill="currentColor"
        d="M124.8 32l46.5 256 303.6 0c30.8 0 57.2-21.9 62.9-52.2L568.9 69.9C572.6 50.2 557.5 32 537.4 32L124.8 32zM254.4 160c0-13.3 10.7-24 24-24l33.6 0 0-33.6c0-13.3 10.7-24 24-24s24 10.7 24 24l0 33.6 33.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-33.6 0 0 33.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-33.6-33.6 0c-13.3 0-24-10.7-24-24z"
      />
      <path
         fill={props.htmlColor || theme.palette.secondary[500]}
        d="M0 8C0-5.3 10.7-16 24-16l45.3 0c27.1 0 50.3 19.4 55.1 46l52.1 286.3c2.1 11.4 12 19.7 23.6 19.7L456 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-255.9 0c-34.8 0-64.6-24.9-70.8-59.1L77.2 38.6c-.7-3.8-4-6.6-7.9-6.6L24 32C10.7 32 0 21.3 0 8zM208 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm224 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM336 78.4c13.3 0 24 10.7 24 24l0 33.6 33.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-33.6 0 0 33.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-33.6-33.6 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l33.6 0 0-33.6c0-13.3 10.7-24 24-24z"
      />
    </SvgIcon>
  );
};
